import { SET_ALL_WORKSPACES } from "../AppState/type";
import { getProfile } from "../profile/action";
import { switchAccount } from "../subscriber/action";
import { requestGetAllAcountLevelMember } from "../ArkchatGroup/action";
import { chatsInView, saveAllWorkspaces } from "../../../utils/workspaceView";

export const setAllWorkspaces = (value) => (dispatch) => {
  saveAllWorkspaces(value);
  dispatch({ type: SET_ALL_WORKSPACES, payload: value });
};

// Reads the store directly: callers run right after a switch, before the
// values they rendered with have caught up.
export const chatsInCurrentView = (list) => (_dispatch, getState) => {
  const state = getState();
  return chatsInView(
    list,
    state?.appStateData?.allWorkspaces,
    state?.profile?.profileData?.data?.activeSubscriber?.id,
  );
};

// While "All" is shown, makes a workspace the active one for an action that
// needs one, without leaving the page or changing the open chat. Returns the
// fresh profile, or null if it couldn't be switched.
export const activateWorkspace = (workspaceId) => async (dispatch, getState) => {
  const profile = () => getState()?.profile?.profileData?.data;
  if (profile()?.activeSubscriber?.id === workspaceId) return profile();
  const res = await dispatch(switchAccount({ switch_subscriber_id: workspaceId }));
  if (!res?.status) return null;
  await dispatch(getProfile(true));
  dispatch(requestGetAllAcountLevelMember());
  return profile();
};
